export default __webpack_public_path__ + "static/media/safety.62c08ec6.svg";